angular.module('GlobalHelpersModule').filter "providerName", ->
  (provider, withTitle) ->
    if provider?
      if withTitle is 'withTitle' && !_.isEmpty(provider.degree)
        # support inconsistent casing here
        (provider.first_name or provider.firstName) + ' ' + (provider.last_name or provider.lastName) + ' ' + provider.degree
      else
        (provider.first_name or provider.firstName) + ' ' + (provider.last_name or provider.lastName)
    else
      ""